import './LegendColorBox.css';

interface LegendColorBoxProps {
  color: string;
}

export function LegendColorBox({ color }: LegendColorBoxProps) {
  return <div className="LegendColorBox" style={{ backgroundColor: color }} />;
}
